// extracted by mini-css-extract-plugin
module.exports = {"blood_drop_logo":"Navbar_blood_drop_logo__3g9oU","all_links":"Navbar_all_links__1HpxW","all_btn":"Navbar_all_btn__26b0H"};